// extracted by mini-css-extract-plugin
export var memberheader = "team-group-module--memberheader--lXQe9";
export var tag = "team-group-module--tag--IX7Or";
export var taggroup = "team-group-module--taggroup--8QizE";
export var teampic = "team-group-module--teampic--xf4j7";